import { render } from "./BackToDetail.vue?vue&type=template&id=4ed29de8"
import script from "./BackToDetail.vue?vue&type=script&lang=js"
export * from "./BackToDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__